import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { LoadingSpinner } from "../components/LoadingSpinner";

/**
 * Routes that should only be accessible to unauthenticated users.
 * Redirects to dashboard if already logged in — or to the destination the
 * user was originally heading for (passed along by ProtectedRoute).
 */
export function GuestRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isAuthenticated) {
    const from = (location.state as { from?: string } | null)?.from;
    // Same-origin path guard: only ever redirect to an in-app path.
    return <Navigate to={from && from.startsWith("/") ? from : "/"} replace />;
  }

  return <Outlet />;
}
